import {addToCartHandler} from "./addToCart";
import app from "../_app";

const product = document.querySelector('.js-product');

if(product) {
    const form = product.querySelector('.js-product-form');
    const deliveryTime = product.querySelector('.js-product-delivery');

    // addToRecentlyViewedProducts(product.dataset.handle);
    if(form) {
        form.addEventListener('submit', addToCartHandler);
        deliveryTime.innerHTML = 'test';
        deliveryTime.innerHTML = app.getNextDeliveryDate();


        const inventoryAlarmContainer = product.querySelector('.js-inventoryAlarmContainer');

        if (inventoryAlarmContainer) {

            if (typeof inventoryAlarmContainer.current !== 'undefined') {

                if (inventoryAlarmContainer.current.childElementCount > 0) {
                    let child = inventoryAlarmContainer.current.lastElementChild;

                    while (child) {
                        inventoryAlarmContainer.current.removeChild(child);
                        child = inventoryAlarmContainer.current.lastElementChild;
                    }
                }
            }
        }
    }
}

